



























































import Loader from '@/contexts/frontend/Loader.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

library.add(faPencilAlt, faTrashAlt, faSearch, faTimes)

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String
  },
  data: function() {
    return {
      loading: false,
      teams: [],
      teamContains: ''
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .ListTeams()
      .then(results => (this.teams = results))
      .finally(() => (this.loading = false))
  },
  methods: {
    findTeams() {
      if (this.teamContains.length > 1) {
        this.$api.clientAdmin
          .FindTeams(this.teamContains)
          .then(results => (this.teams = results))
      } else if (this.teamContains.length == 0) {
        this.loading = true
        this.$api.clientAdmin
          .ListTeams()
          .then(results => (this.teams = results))
          .finally(() => (this.loading = false))
      }
    },
    clearSearch() {
      this.teamContains = ''
      this.findTeams()
    }
  },
  computed: {
    teamsFound() {
      return this.teams.length > 0
    },
    hasSearchCriteria() {
      return this.teamContains.length > 0
    }
  }
}
